import {
  INMUEBLE_RED_MARKETPLACE_SITE,
  PUBLIC_MARKETPLACE_SITES,
  resolvePublicMarketplaceSiteByHostname,
} from './publicMarketplaceSites';

export const PUBLIC_MARKETPLACE_ROOT_HOSTNAME =
  INMUEBLE_RED_MARKETPLACE_SITE.rootHostname;

export interface PublicMarketplaceLegacyRedirect {
  hostname: string;
  canonicalPath: string;
}

export const PUBLIC_MARKETPLACE_LEGACY_REDIRECTS: readonly PublicMarketplaceLegacyRedirect[] =
  [];

export const PUBLIC_MARKETPLACE_ROUTED_HOSTNAMES = [
  ...PUBLIC_MARKETPLACE_SITES.flatMap((site) => site.routedHostnames),
] as const;

const PUBLIC_MARKETPLACE_LEGACY_REDIRECT_BY_HOSTNAME: ReadonlyMap<
  string,
  PublicMarketplaceLegacyRedirect
> = new Map(
  PUBLIC_MARKETPLACE_LEGACY_REDIRECTS.map((redirect) => [
    redirect.hostname,
    redirect,
  ])
);

export function getPublicMarketplaceLegacyRedirect(
  hostname: string
): PublicMarketplaceLegacyRedirect | null {
  return (
    PUBLIC_MARKETPLACE_LEGACY_REDIRECT_BY_HOSTNAME.get(
      hostname.trim().toLowerCase()
    ) ?? null
  );
}

export function isPublicMarketplaceRoutedHostname(hostname: string): boolean {
  return resolvePublicMarketplaceSiteByHostname(hostname) !== null;
}
